import { MypageNovelNovelIdChapterChapterIdDeleteInputModel } from "./DeleteInputModel"
import { httpDelete } from "../../../../../../../libs/http/httpDelete"

export const deleteMypageNovelNovelIdChapterChapterId = async (
  model: MypageNovelNovelIdChapterChapterIdDeleteInputModel,
): Promise<void> => {
  return httpDelete<void>(
    "/v1/mypage/novel/{novel_id}/chapter/{chapter_id}",
    model,
  )
}
